/* kr-header.js — KREACT header behavior (Phase 3)
   - Desktop nav: .kr-scrolled box-shadow after 60px scroll (port of source).
   - Mobile: hamburger menu open/close + scroll recolor of topbar (port of source).
   - Cart badge: live count via Dawn pub/sub (PUB_SUB_EVENTS.cartUpdate).
   Vanilla, defer-loaded. */
(function () {
  'use strict';

  function initNavScroll() {
    var nav = document.getElementById('krNav');
    if (!nav || nav.dataset.krBound) return;
    nav.dataset.krBound = '1';
    var onScroll = function () {
      if (window.scrollY > 60) nav.classList.add('kr-scrolled');
      else nav.classList.remove('kr-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initMobileMenu() {
    var hamb = document.getElementById('krHamb');
    var overlay = document.getElementById('krMenuOverlay');
    var menu = document.getElementById('krMenu');
    var cart = document.getElementById('krCart');
    var logo = document.getElementById('krTopbarLogo');
    var acct = document.getElementById('krAcct');
    if (!hamb || !overlay || !menu || hamb.dataset.krBound) return;
    hamb.dataset.krBound = '1';

    function open() {
      hamb.classList.add('is-open');
      overlay.classList.add('is-open');
      menu.classList.add('is-open');
      if (cart) cart.classList.add('menu-open');
      if (logo) logo.classList.add('menu-open');
      if (acct) acct.classList.add('menu-open');
      hamb.setAttribute('aria-expanded', 'true');
      overlay.setAttribute('aria-hidden', 'false');
      menu.setAttribute('aria-hidden', 'false');
    }
    function close() {
      hamb.classList.remove('is-open');
      overlay.classList.remove('is-open');
      menu.classList.remove('is-open');
      if (cart) cart.classList.remove('menu-open');
      if (logo) logo.classList.remove('menu-open');
      if (acct) acct.classList.remove('menu-open');
      hamb.setAttribute('aria-expanded', 'false');
      overlay.setAttribute('aria-hidden', 'true');
      menu.setAttribute('aria-hidden', 'true');
    }

    hamb.addEventListener('click', function () {
      hamb.classList.contains('is-open') ? close() : open();
    });
    overlay.addEventListener('click', close);
    menu.querySelectorAll('.kr-menu-pill').forEach(function (p) {
      p.addEventListener('click', function () { setTimeout(close, 80); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && hamb.classList.contains('is-open')) close();
    });
  }

  function initTopbarRecolor() {
    var hamb = document.getElementById('krHamb');
    var cart = document.getElementById('krCart');
    var logo = document.getElementById('krTopbarLogo');
    var acct = document.getElementById('krAcct');
    if (!hamb || hamb.dataset.krRecolor) return;
    hamb.dataset.krRecolor = '1';
    // Hero is dark only on pages that have one; elsewhere keep the bar solid.
    var hero = document.querySelector('[data-kr="hero"]') || document.querySelector('.hero');

    function setSolid(on) {
      [hamb, cart, logo, acct].forEach(function (el) {
        if (!el) return;
        if (on) el.classList.add('nav-scrolled');
        else el.classList.remove('nav-scrolled');
      });
    }
    function update() {
      if (!hero) { setSolid(true); return; }
      setSolid(window.scrollY > hero.offsetHeight - 60);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function setCount(n) {
    var spans = document.querySelectorAll('[data-kr-cart-count]');
    spans.forEach(function (s) {
      s.textContent = n;
      if (n > 0) s.removeAttribute('hidden');
      else s.setAttribute('hidden', '');
    });
  }

  function initCartCount() {
    if (window.__krCartBound) return;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.__krCartBound = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var data = event && event.cartData;
        if (data && typeof data.item_count !== 'undefined') setCount(data.item_count);
      });
    }
  }

  function initCartToggles() {
    document.querySelectorAll('[data-kr-cart-toggle]').forEach(function (btn) {
      if (btn.dataset.krBound) return;
      btn.dataset.krBound = '1';
      btn.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer');
        // Only intercept when the Dawn cart drawer is present; otherwise let the link go to /cart.
        if (drawer && typeof drawer.open === 'function') {
          e.preventDefault();
          drawer.open(btn);
        } else if (btn.tagName === 'BUTTON') {
          // Mobilné tlačidlo nie je odkaz — bez bočného košíka vedie na stránku košíka
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      });
    });
  }

  function init() {
    initNavScroll();
    initMobileMenu();
    initTopbarRecolor();
    initCartCount();
    initCartToggles();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
